var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "57.166 60.861 111.963 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9439 81.728C95.7912 81.728 98.8995 78.6198 98.8995 74.7725C98.8995 70.9252 95.7912 67.8169 91.9439 67.8169H78.0327C66.5126 67.8169 57.166 77.1634 57.166 88.6836V144.328C57.166 155.848 66.5126 165.195 78.0327 165.195H91.9439C95.7912 165.195 98.8995 162.087 98.8995 158.239C98.8995 154.392 95.7912 151.284 91.9439 151.284H78.0327C74.1854 151.284 71.0772 148.176 71.0772 144.328V88.6836C71.0772 84.8363 74.1854 81.728 78.0327 81.728H91.9439ZM166.412 121.418C169.129 118.701 169.129 114.289 166.412 111.572L138.59 83.7495C135.873 81.0325 131.46 81.0325 128.743 83.7495C126.026 86.4665 126.026 90.879 128.743 93.596L144.698 109.55H98.8995C95.0522 109.55 91.9439 112.659 91.9439 116.506C91.9439 120.353 95.0522 123.461 98.8995 123.461H144.698L128.743 139.416C126.026 142.133 126.026 146.545 128.743 149.262C131.46 151.979 135.873 151.979 138.59 149.262L166.412 121.44V121.418Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutActive);
export default __webpack_public_path__ + "static/media/logout-active.9d68506a3d8477bb9e819b4283d7051c.svg";
export { ForwardRef as ReactComponent };